export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    links: {
      type: [Array, Object],
      default: () => ({}),
    },
    meta: {
      type: Object,
      default: () => ({}),
    },
    attributes: {
      type: Object,
      default: () => ({}),
    },
    relationships: {
      type: [Array, Object],
      default: () => ({}),
    },
    fluid: {
      type: Boolean,
      default: false,
    },
  },
}
